export default "__VITE_ASSET__BIYiQnM5__"